export enum CompanyListEvents {
  SEARCH_COMPANY = 'searchCompany',
  SEARCH_CLEAR = 'clearSearch',
  LOAD_MORE_COMPANIES = 'loadMoreCompanies',
}

export const COMPANIES_LIST_ID = 'companies-filter-list';
